<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent max-width="600px" transition="dialog-transition">
      <v-card>
        <v-card-title>
          <span class="headline">Editando créditos do grupo econômico</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-col cols='12' class="pa-0">
              <v-col cols='12' class="pa-0">
                <v-text-field 
                  v-model="economic_group_credit.original_limit_aux" 
                  type="number" 
                  :rules="required"
                  label="Limite de Crédito (R$)" 
                  @input="recalcLimit()"
                ></v-text-field>
              </v-col>
              <v-col cols='12' class="pa-0">
                <v-text-field 
                  :value="economic_group_credit?.limit_aux?.replace(/\d(?=(\d{3})+\.)/g, '$&,')"
                  label="Crédito atualizado (R$)" 
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols='12' class="pa-0">
                <v-text-field 
                  v-model="economic_group_credit.blockingTime" 
                  :rules="required"
                  label="Tempo para Bloqueio"
                ></v-text-field>
              </v-col>
              <v-col cols='12' class="pa-0">
                <v-text-field 
                  v-model="economic_group_credit.comment" 
                  label="Comentários"
                ></v-text-field>
              </v-col>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn cancel @click="closeDialog"></f-btn>
          <f-btn save @click="emitUpdate"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading loadingText="Salvando..." v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import Api from '@/api/index';
import validations from '@/mixins/validations.js'

export default {
  name: 'DialogEditEconomicGroupCredit',
  mixins: [validations],
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    model_economic_group: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      saving: false,
      economic_group_credit: {
        blockingTime: null,
        comment: null,
        limit: "",
        limit_aux: "",
        original_limit: "",
        original_limit_aux: "",
        id: null
      },
      can_recalc: false,
      new_limit: 0,
    }
  },
  methods: {
    setEconomicGroupCredit() {
      const credit = this.model_economic_group.economic_group_credit
      if (credit && credit.data && credit.data.attributes) {
        const { blockingTime, comment, limit, original_limit, id } = credit.data.attributes
        this.economic_group_credit = {
          blockingTime: blockingTime,
          limit: limit,
          limit_aux: limit,
          original_limit_aux: original_limit,
          original_limit: original_limit,
          id: id,
          comment: comment || null
        }
      } else {
        this.economic_group_credit = {
          blockingTime: null,
          comment: null,
          limit: "",
          limit_aux: "",
          original_limit: "",
          original_limit_aux: "",
          id: null
        }
      }
      this.can_recalc = true
    },
    recalcLimit() {
      if (!this.can_recalc) return
      
      const original_limit_aux = parseFloat(this.economic_group_credit.original_limit_aux) || 0
      const original_limit = parseFloat(this.economic_group_credit.original_limit) || 0
      const limit = parseFloat(this.economic_group_credit.limit) || 0
      
      this.new_limit = original_limit_aux - original_limit + limit
      
      if (!isNaN(this.new_limit)) {
        this.economic_group_credit.original_limit = original_limit_aux
        this.economic_group_credit.limit = this.new_limit
        this.economic_group_credit.limit_aux = this.new_limit.toFixed(2)
      }
    },
    emitUpdate() {
      if (this.$refs.form.validate()) {
        const limit = parseFloat(this.economic_group_credit.limit_aux) || 0
        const original_limit = parseFloat(this.economic_group_credit.original_limit_aux) || 0
        
        const economic_group = {
          id: this.model_economic_group.id,
          economic_group_credit_attributes: {
            id: this.economic_group_credit.id,
            limit: limit,
            original_limit: original_limit,
            blockingTime: this.economic_group_credit.blockingTime,
            comment: this.economic_group_credit.comment
          }
        }
        
        this.saving = true
        Api.EconomicGroup.update(economic_group).then(() => {
          this.successSaved()
          this.$emit('updated')
          this.closeDialog()
        }).catch(() => {
          this.errorUpdated()
        }).finally(() => {
          this.saving = false
        })
      }
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.setEconomicGroupCredit()
      }
    }
  },
  mounted() {
    this.setEconomicGroupCredit()
  },

}
</script>

